<template>
  <PageCheckoutItems/>
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import CheckoutRouteMixin from '~/mixins/CheckoutRouteMixin'
import PageCheckoutItems from '@theme/components/cart/PageCheckoutItems'

const PAGE = {
  name: 'RouteCheckoutItems',
  nuxtI18n: {
    paths: {
      cs: '/kosik',
      de: '/warenkorb',
      en: '/cart',
      sk: '/kosik',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageCheckoutItems,
  },
  mixins: [AppRouteMixin, CheckoutRouteMixin],
}
export default PAGE
</script>
